import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S17.1 0 11 0m0 19.551c-5 0-9-3.91-9-8.798s4-8.798 9-8.798 9 3.91 9 8.798-4 8.798-9 8.798m4.9-9.189c-.1-.098-.1-.196-.2-.293l-4-3.91a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l2.3 2.248H7c-.6 0-1 .391-1 .978s.4.978 1 .978h5.6l-2.3 2.248a.93.93 0 0 0 0 1.369c.2.195.5.293.7.293s.5-.098.7-.293l4-3.91c.1-.098.2-.196.2-.294.1-.293.1-.489 0-.782"
    }, null, -1)
  ]))]))
}
export default { render: render }